module.exports = __webpack_public_path__ + "static/media/course-book-cover.b1c19545.png";